import { render, staticRenderFns } from "./TicketLinkParts.vue?vue&type=template&id=08f00ee1&scoped=true"
import script from "./TicketLinkParts.vue?vue&type=script&lang=ts"
export * from "./TicketLinkParts.vue?vue&type=script&lang=ts"
import style0 from "./TicketLinkParts.vue?vue&type=style&index=0&id=08f00ee1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f00ee1",
  null
  
)

export default component.exports